import { useEffect } from "react";
import { hotjar } from "react-hotjar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { GOOGLE_ANALYTICS, HOTJAR_ID } from "./lib/utils/constants";
import ReactGA from "react-ga4";
import Intro from "./newui/Intro";
import Results from "./newui/Results";

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV === "developement") return;
    hotjar.initialize({ id: HOTJAR_ID, sv: 6 });
    ReactGA.initialize(GOOGLE_ANALYTICS);
    ReactGA.send({ hitType: "pageview", page: window?.location?.pathname });
  }, []);

  return (
    <div className="">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Intro />} />
          <Route path="/results" element={<Results />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
